/* ==========================================================================
   Aurelys — comportamiento de la landing dentro de Shopify
   --------------------------------------------------------------------------
   Lo que NO está aquí, a propósito:
   - Nada que toque el precio, la variante ni la cantidad DEL PEDIDO COD. Ese
     pedido lo arma el popup de la app, que es su único dueño; ese modelo es
     el que eliminó las carreras de precios en la landing de RYZE. Los packs
     siguen siendo vitrina para el COD: lo único que gobiernan es el enlace
     del pago anticipado con tarjeta, que es un camino aparte (un permalink
     al checkout de Shopify) y nunca se mezcla con el formulario COD.
   - Ningún addEventListener('scroll'). Todo lo que reacciona al scroll usa
     IntersectionObserver.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Cada pieza se engancha una sola vez por elemento: arrancar() vuelve a
     correr cuando el editor de temas recarga una sección. */
  function nuevos(sel) {
    return $$(sel).filter(function (e) {
      if (e.hasAttribute('data-au-listo')) return false;
      e.setAttribute('data-au-listo', '');
      return true;
    });
  }

  function arrancar() {

  /* ---------- avisos: fila fija en escritorio, rotación en teléfono -------- */
  nuevos('[data-au-avisos]').forEach(function (pista) {
    var msgs = $$('span', pista);
    if (msgs.length < 2) { msgs.forEach(function (m) { m.classList.add('on'); }); return; }
    var ancho = window.matchMedia('(min-width: 1000px)');
    var t = null, i = 0;
    function arranca() {
      clearInterval(t);
      if (ancho.matches || reduce) { msgs.forEach(function (m) { m.classList.add('on'); }); return; }
      msgs.forEach(function (m, k) { m.classList.toggle('on', k === 0); });
      i = 0;
      t = setInterval(function () {
        msgs[i].classList.remove('on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('on');
      }, 3800);
    }
    arranca();
    if (ancho.addEventListener) ancho.addEventListener('change', arranca); else ancho.addListener(arranca);
  });

  /* ---------- fechas de entrega ------------------------------------------- */
  (function () {
    if (!nuevos('[data-au-fecha="envio"]').length) return;
    var dias  = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
    var meses = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    function fmt(d) { return dias[d.getDay()] + ' ' + d.getDate() + ' ' + meses[d.getMonth()]; }
    var hoy = new Date();
    function mas(n) { var d = new Date(hoy); d.setDate(d.getDate() + n); return d; }
    var e1 = $('[data-au-fecha="envio"]'), e2 = $('[data-au-fecha="llega"]');
    if (e1) e1.textContent = fmt(mas(1));
    if (e2) e2.textContent = fmt(mas(2)) + ' a ' + fmt(mas(4));
  })();

  /* ---------- galería: carrusel con deslizamiento ------------------------
     El desplazamiento y el anclaje los hace el navegador (scroll-snap): el
     dedo funciona sin JS. Aquí solo se sincronizan miniaturas y flechas con
     la diapositiva que se está viendo, y se mueve la pista al tocar una
     miniatura o una flecha. */
  nuevos('[data-au-gal]').forEach(function (gal) {
    var pista  = $('[data-au-pista]', gal);
    var slides = $$('[data-au-slide]', gal);
    var tiras  = $$('[data-au-tira]', gal);
    var prev   = $('[data-au-gal-prev]', gal);
    var sig    = $('[data-au-gal-sig]', gal);
    if (!pista || slides.length < 1) return;
    var suave = reduce ? 'auto' : 'smooth';
    var actual = 0;

    if (slides.length < 2) {
      if (prev) prev.remove();
      if (sig) sig.remove();
      $('[data-au-tiras]', gal) && $('[data-au-tiras]', gal).remove();
      return;
    }

    var visor = $('.gal__visor', gal);
    function marcar(i) {
      actual = i;
      if (visor) visor.toggleAttribute('data-au-en-primera', i === 0);
      tiras.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (prev) prev.disabled = i === 0;
      if (sig) sig.disabled = i === slides.length - 1;
      // la miniatura activa siempre a la vista, si la tira se desplaza
      var t = tiras[i];
      if (t && t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth + 1) {
        var p = t.parentElement;
        var izq = t.offsetLeft - p.offsetLeft - (p.clientWidth - t.clientWidth) / 2;
        p.scrollTo({ left: izq, behavior: suave });
      }
    }

    function ir(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      pista.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: suave });
      marcar(i);
    }

    tiras.forEach(function (t, k) {
      t.addEventListener('click', function () { ir(k); });
    });
    if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
    if (sig)  sig.addEventListener('click', function () { ir(actual + 1); });

    /* Qué diapositiva se está viendo. Esto es lo que mantiene la miniatura
       correcta cuando el cambio lo hace el DEDO y no un botón.

       Va sobre el scroll de la PISTA, no sobre el de la página: la regla de no
       escuchar 'scroll' existe por el coste en el scroll del documento, que
       dispara en cada píxel de toda la página. Aquí la superficie está acotada
       a un elemento y el trabajo se limita a un cuadro con rAF. Se eligió por
       encima de IntersectionObserver porque el observador solo avisa al cruzar
       un umbral: si el dedo suelta a medio camino y el anclaje termina el
       viaje, hay recorridos en los que no cruza nada y la miniatura se queda
       mintiendo. */
    var pendiente = false;
    pista.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        var ancho = slides[0].offsetWidth || pista.clientWidth;
        var i = Math.round(pista.scrollLeft / ancho);
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== actual) marcar(i);
      });
    }, { passive: true });

    // teclado: la pista es enfocable, así que las flechas del teclado mandan
    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(actual + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); ir(actual - 1); }
    });

    marcar(0);
  });

  /* ---------- packs: vitrina del COD, mando del botón de tarjeta ----------
     Para el pedido CONTRA ENTREGA siguen siendo vitrina: ni cantidad, ni
     variante, ni precio — eso lo arma el popup de la app COD, su único dueño.
     Lo único que sí gobiernan es el SEGUNDO camino de compra: el enlace de
     pago anticipado con tarjeta toma texto, cantidad y código de descuento
     del pack resaltado (atributos data-tarjeta-* que pinta el Liquid). */
  nuevos('[data-au-packs]').forEach(function (cont) {
    var packs = $$('[data-au-pack]', cont);
    if (!packs.length) return;
    var panel  = cont.closest('.compra');
    var caja   = panel ? $('[data-au-tarjeta-caja]', panel) : null;
    var btn    = caja ? $('[data-au-tarjeta]', caja) : null;
    var btnTxt = btn ? $('[data-au-tarjeta-txt]', btn) : null;
    var envio  = caja ? $('[data-au-tarjeta-envio]', caja) : null;
    function pintaTarjeta(el) {
      if (!btn) return;
      var texto = el.getAttribute('data-tarjeta-texto');
      if (!texto) { caja.setAttribute('hidden', ''); return; }
      caja.removeAttribute('hidden');
      if (btnTxt) btnTxt.textContent = texto;
      if (envio) {
        var etx = el.getAttribute('data-tarjeta-envio');
        if (etx) { envio.textContent = etx; envio.removeAttribute('hidden'); }
        else { envio.setAttribute('hidden', ''); }
      }
      var url = btn.getAttribute('data-au-tarjeta-base') + ':' + (el.getAttribute('data-tarjeta-cant') || '1');
      var dcto = el.getAttribute('data-tarjeta-dcto');
      if (dcto) url += '?discount=' + encodeURIComponent(dcto);
      btn.setAttribute('href', url);
    }
    function marca(el) {
      packs.forEach(function (p) {
        var on = p === el;
        p.classList.toggle('on', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      pintaTarjeta(el);
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function () { marca(p); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); marca(p); }
      });
    });
  });

  /* ---------- barras de reseñas: el porcentaje vive en el CSS -------------- */
  function pintaBarras(raiz) {
    $$('.res__b .via i', raiz).forEach(function (b, k) {
      var pct = parseFloat(getComputedStyle(b).getPropertyValue('--au-pct')) || 0;
      if (reduce) { b.style.transform = 'scaleX(' + (pct / 100) + ')'; return; }
      setTimeout(function () { b.style.transform = 'scaleX(' + (pct / 100) + ')'; }, k * 55);
    });
  }

  /* ---------- revelado de secciones y puntos de la línea de tiempo --------- */
  (function () {
    var items = nuevos('.rev, .linea-t__i');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('vis'); });
      pintaBarras(document);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vis');
        if (e.target.querySelector && e.target.querySelector('.res__b')) pintaBarras(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (i) { io.observe(i); });
  })();

  /* ---------- botón flotante ---------------------------------------------
     No es un segundo camino de compra: es un atajo al mismo botón de la app.
     Si la app todavía no terminó de arrancar, el toque queda pendiente y se
     dispara al habilitarse — un botón que no responde se lee como página
     rota, y el peso del widget (391KB) es un piso que no se puede bajar. */
  (function () {
    if (!nuevos('[data-au-frap]').length) return;
    var frap = $('[data-au-frap]');
    var forms = $$('.compra__form');
    if (!frap || !forms.length) return;
    var form = forms[0];

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          frap.classList.toggle('vis', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(form);
    } else {
      frap.classList.add('vis');
    }

    var esperando = false;
    function botonApp() { return document.getElementById('rsi_buy_now_button'); }

    frap.addEventListener('click', function (e) {
      var b = botonApp();
      if (!b) return;                     // sin app: el href ancla al formulario
      e.preventDefault();
      form.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      if (!b.disabled) { b.click(); return; }
      if (esperando) return;
      esperando = true;
      var t0 = Date.now();
      var iv = setInterval(function () {
        var bb = botonApp();
        if (bb && !bb.disabled) { clearInterval(iv); esperando = false; bb.click(); }
        else if (Date.now() - t0 > 15000) { clearInterval(iv); esperando = false; }
      }, 120);
    });
  })();

  /* ---------- enlaces internos que apuntan al pedido ---------------------- */
  nuevos('[data-au-ir-pedido]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var form = $('.compra__form');
      if (!form) return;
      e.preventDefault();
      form.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      var b = document.getElementById('rsi_buy_now_button');
      if (b && !b.disabled) b.click();
    });
  });

  }

  /* --- Cuándo arrancar --------------------------------------------------
     Este archivo lo carga la sección del hero, o sea que se ejecuta A MITAD
     del documento: al correr, las secciones de más abajo todavía no existen
     en el DOM. Sin esperar a DOMContentLoaded, los 31 bloques con revelado
     se quedaban invisibles para siempre. Y `shopify:section:load` es lo que
     hace que todo siga funcionando cuando el editor de temas repinta una
     sección suelta. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
